import { ClipboardCheck, Lock } from 'lucide-react'

import { FleetEditMode, OrgStatus } from '../models/user'

/** Why a roster isn't plain editable: a live policy sends every change to Cai first, or underwriting has it frozen. */
export function FleetStatusBanner({
  label,
  mode,
  status,
}: {
  label: string
  mode: FleetEditMode
  status: OrgStatus | undefined
}) {
  const isReviewed = mode === FleetEditMode.REVIEWED
  const Icon = isReviewed ? ClipboardCheck : Lock
  return (
    <div className="flex items-center gap-4 rounded-xl border border-blue-200 bg-blue-50 px-5 py-4">
      <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-blue-100">
        <Icon className="text-cai-blue size-5" />
      </div>
      <div className="flex flex-1 flex-col">
        <span className="text-sm font-semibold text-blue-900">
          {isReviewed || status === OrgStatus.ACTIVE ? 'Your policy is active' : 'Underwriting in progress'}
        </span>
        <span className="text-sm text-blue-700">{description(label, mode, status)}</span>
      </div>
    </div>
  )
}

function description(label: string, mode: FleetEditMode, status: OrgStatus | undefined): string {
  if (mode === FleetEditMode.REVIEWED) {
    return `Add, edit or remove ${label} as usual — Cai checks each change before it goes on your policy.`
  }
  if (status === OrgStatus.ACTIVE) {
    return `Your ${label} are locked while you are on a policy. Ask Cai to make a change.`
  }
  return `Your fleet is currently under review. You cannot make changes to your ${label} until underwriting is complete.`
}
